import { createContext, useState } from 'react';

export enum PageAnimation {
  RightToLeft = 'rightToLeft',
  LeftToRight = 'leftToRight',
}

export interface AppContextInterface {
  pageAnimation: PageAnimation;
  suppressBackButton: boolean;
  onBack: undefined | (() => void);
  onClose: undefined | (() => void);

  setPageAnimation: React.Dispatch<React.SetStateAction<PageAnimation>>;
  setSuppressBackButton: React.Dispatch<React.SetStateAction<boolean>>;
  setOnBack: React.Dispatch<React.SetStateAction<undefined | (() => void)>>;
  setOnClose: React.Dispatch<React.SetStateAction<undefined | (() => void)>>;
}

export const AppContext = createContext<AppContextInterface | null>(null);

interface Props {
  children: React.ReactNode;
}

export function AppContextProvider({ children }: Props) {
  const [pageAnimation, setPageAnimation] = useState<PageAnimation>(PageAnimation.RightToLeft);
  const [suppressBackButton, setSuppressBackButton] = useState(false);
  const [onBack, setOnBack] = useState<undefined | (() => void)>(undefined);
  const [onClose, setOnClose] = useState<undefined | (() => void)>(undefined);

  const appContext: AppContextInterface = {
    pageAnimation,
    suppressBackButton,
    onBack,
    onClose,

    setPageAnimation,
    setSuppressBackButton,
    setOnBack,
    setOnClose,
  };

  return <AppContext value={appContext}>{children}</AppContext>;
}
